import React, { useState, useEffect,useRef,useCallback } from 'react';
import IntlMessages from '@iso/components/utility/intlMessages';
import HarvestModalWrapper from "./HarvestModal.styles";
import {
  Form,
  Input,
  Button,
  Select,
  Row,
  Col,
  DatePicker,
  Tabs,
  InputNumber,
  message,
} from "antd";
import Loader from "@iso/components/utility/loader";
import moment, { localeData } from 'moment';
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import _, { values } from "lodash";
import { harvestType } from "@iso/constants/harvestType";
import modalActions from "@iso/redux/modal/actions";
import { windDirection } from "@iso/constants/windDirection";
import { moonCycle } from "@iso/constants/moonCycle";
import { dateHelper } from "@iso/lib/helpers/dateHelper";
import 'react-tagsinput/react-tagsinput.css';
const { Option } = Select;
const { closeModal } = modalActions;
const { TabPane } = Tabs
export default function AddActivityModal(props) {
  const [form] = Form.useForm();
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [dataObject,setDataObject] = useState({})

  const onChangeTab = (key) => {
    setActiveTab(key);
  };

  useEffect(() => {
    if (props?.activity) {
      if (props?.activity?.length > 0) {
        setDataObject(props?.activity);
      }
    setFields([
      {
        name: ["activity", "type"],
        value: props?.activity?.type || "",
      }, 
      {
        name: ['activity', 'start_time'],
        value: props?.activity?.start_time ? moment(props?.activity?.start_time) : '',
      },
      {
        name: ['activity', 'finish_time'],
        value: props?.activity?.finish_time ? moment(props?.activity?.finish_time) : '',
      },
      {
        name: ['activity', 'machinery_time'],
        value: props?.activity?.machinery_time ? moment(props?.activity?.machinery_time) : '',
      },
      {
        name: ['activity', 'layer_plastic'],
        value: props?.activity?.layer_plastic || '' ,
      },
      {
        name: ['activity', 'plastic_cost'],
        value: props?.activity?.plastic_cost || '' ,
      },
      {
        name: ['activity', 'resources'],
        value: props?.activity?.resources || '' ,
      },
      {
        name: ['activity', 'resources_cost'],
        value: props?.activity?.resources_cost || '' ,
      },
      {
        name: ['activity', 'machinery_cost'],
        value: props?.activity?.machinery_cost || '' ,
      },
    ]);
  }}, [props?.activity]);

  const renderOptionsHarvestType = () => {
    let options = [];
    _.forEach(harvestType, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select Activity" allowClear size="large">
        {options}
      </Select>
    );
  };
  const renderOptionWindDirection = (windDirection) => {
    let options = [];
    _.forEach(windDirection, (type, index) => {
      options.push(
        <Option key={index} value={type.value}>
          <div>{type.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select wind direction" allowClear size="large">
        {options}
      </Select>
    );
  };
  const renderOptionMoonCycle = (moonPhase) => {
    let options = [];
    _.forEach(moonPhase, (phase, index) => {
      options.push(
        <Option key={index} value={phase.value}>
          <div>{phase.label}</div>
        </Option>
      );
    });
    return (
      <Select placeholder="Select moon cycle" allowClear size="large">
        {options}
      </Select>
    );
  };
const renderOptionsBlock = () => {

  let options = [];
  // _.forEach(moonPhase, (phase, index) => {
  //   options.push(
  //     <Option key={index} value={phase.value}>
  //       <div>{phase.label}</div>
  //     </Option>
  //   );
  // });
  return (
    <Select placeholder="Select Block" allowClear size="large">
      {options}
    </Select>
  );
}
  const handleSubmit = () => {
    form
    .validateFields()
    .then((values) => {
      setLoading(true);
      setLoading(false);
      props.cancelModalActivity(); // Close the modal after submission
    })
    .catch((errorInfo) => {
      console.log('Validation failed:', errorInfo);
    });
  }

  const cancelBlockActivity = () => {
    props.cancelModalActivity();
    setActiveTab("1");
    setLoading(false);
    form.resetFields();
  }
  return (
    <HarvestModalWrapper
      visible={props.visibleActivity}
      onCancel={cancelBlockActivity}
      title= {props.editActivity ? 'Edit Activity' : 'Add Activity'}
      footer={[
        <Button key="back" onClick={cancelBlockActivity} className="cancel-button">
          {<IntlMessages id="propertyPage.modal.cancel" />}
        </Button>,
        <Button key="submit" className="btn-success" type="primary" onClick={handleSubmit} loading={loading}>
          {<IntlMessages id="propertyPage.modal.save" />}
        </Button>,
      ]}
    >
     <Tabs
          defaultActiveKey="1"
          className="form-body"
          onChange={onChangeTab}
          activeKey={activeTab}
        >
          <TabPane
            tab={<IntlMessages id="propertyPage.mobModal.detailTab" />}
            key="1"
          >
            {modalLoading ? (
              <Loader />
            ) : (
              <Form
                form={form}
                layout="vertical"
                scrollToFirstError
                fields={fields}
                id="#1"
              >

<Form.Item
                    name={["activity", "type"]}
                    className="isoInputWrapper"
                    label={<IntlMessages id="Block Activity" />}
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                  >
                    {renderOptionsHarvestType()}
                  </Form.Item>
                  <Form.Item
                    name={["activity", "block"]}
                    className="isoInputWrapper"
                    label={<IntlMessages id="Block" />}
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                  >
                    {renderOptionsBlock()}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return prevValues["activity"];
                    }}
                  >
                    {({ getFieldValue }) => {
                      if (getFieldValue("activity")) {
                        if (getFieldValue("activity").type === "field_Prep") {
                          return (
                            <>
                              <AcreageInput>
                                <Form.Item
                                  name={["activity", "plastic"]}
                                  className="isoInputWrapper"
                                  label="Lay the plastic (acres)"
                                  rules={[
                                    {
                                      required: true,
                                      message: "This field is required",
                                    },
                                    {
                                      type: "number",
                                    },
                                  ]}
                                  style={{ width: "100%" }}
                                >
                                  <InputNumber
                                    size="large"
                                    placeholder="Input your Lay the plastic"
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                                <SuffixAddon>
                                  {props.propertyAcreageUnit
                                    ? props.propertyAcreageUnit
                                    : "acres"}
                                </SuffixAddon>
                              </AcreageInput>
                              <Form.Item
                                name={["activity", "plastic_cost"]}
                                className="isoInputWrapper"
                                label="Plastic Cost"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    type: "number",
                                  },
                                ]}
                                style={{ width: "100%" }}
                              >
                                <InputNumber
                                  size="large"
                                  placeholder="Plastic Cost (Cost per acre)"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                              <Form.Item
                                name={["activity", "people"]}
                                className="isoInputWrapper"
                                label="Resources"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    type: "number",
                                  },
                                ]}
                                style={{ width: "100%" }}
                              >
                                <InputNumber
                                  size="large"
                                  placeholder="Input Number of People"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            </>
                          );
                        }
                      }
                    }}
                  </Form.Item>
                  <Row>
                    <Col xs={{ span: 24 }} md={{ span: 11 }}>
                      <Form.Item
                        name={["activity", "start_time"]}
                        className="isoInputWrapper"
                        label="Start Time"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ]}
                      >
                        <DatePicker
                          size="large"
                          style={{ width: "100%" }}
                          showTime
                          format="YYYY-MM-DD HH:mm:ss"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 12, offset: 1 }}>
                      <Form.Item
                        name={["activity", "finish_time"]}
                        className="isoInputWrapper"
                        label="Finish Time"
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ]}
                      >
                        <DatePicker
                          size="large"
                          style={{ width: "100%" }}
                          showTime
                          format="YYYY-MM-DD HH:mm:ss"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return prevValues["activity"];
                    }}
                  >
                    {({ getFieldValue }) => {
                      if (getFieldValue("activity")) {
                        if (getFieldValue("activity").type === "field_Prep") {
                          return (
                            <>
                              <Form.Item
                                name={["activity", "resource_cost"]}
                                className="isoInputWrapper"
                                label="Resource Cost"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    type: "number",
                                  },
                                ]}
                                style={{ width: "100%" }}
                              >
                                <InputNumber
                                  size="large"
                                  placeholder="Input Resource Cost per hour"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["activity", "machinery_time"]}
                                    className="isoInputWrapper"
                                    label="Machinery Time"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      size="large"
                                      style={{ width: "100%" }}
                                      showTime
                                      format="YYYY-MM-DD HH:mm:ss"
                                    />
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 11, offset: 2 }}
                                >
                                  <Form.Item
                                    name={["activity", "machinery_cost"]}
                                    className="isoInputWrapper"
                                    label="Machinery Cost"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                      {
                                        type: "number",
                                      },
                                    ]}
                                    style={{ width: "100%" }}
                                  >
                                    <InputNumber
                                      size="large"
                                      placeholder="Cost per hour"
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                      }
                    }}
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => {
                      return prevValues["activity"];
                    }}
                  >
                    {({ getFieldValue }) => {
                      if (getFieldValue("activity")) {
                        if (getFieldValue("activity").type === "plant") {
                          return (
                            <>
                              <Form.Item
                                name={["activity", "resource"]}
                                className="isoInputWrapper"
                                label="Resource"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    type: "number",
                                  },
                                ]}
                                style={{ width: "100%" }}
                              >
                                <InputNumber
                                  size="large"
                                  placeholder="Resource"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                              <Form.Item
                                name={["activity", "machinery_time"]}
                                className="isoInputWrapper"
                                label="Machinery Time"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                              >
                                <DatePicker
                                  size="large"
                                  style={{ width: "100%" }}
                                  placeholder="Select time"
                                  showTime
                                  format="YYYY-MM-DD HH:mm:ss"
                                />
                              </Form.Item>
                              <Form.Item
                                name={["activity", "seeding_cost"]}
                                className="isoInputWrapper"
                                label="Seeding cost or Seed Cost"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    type: "number",
                                  },
                                ]}
                                style={{ width: "100%" }}
                              >
                                <InputNumber
                                  size="large"
                                  placeholder="cost per kg or cost per seedling"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                              <TemperatureInput>
                                <Form.Item
                                  name={["activity", "temperature"]}
                                  className="isoInputWrapper"
                                  label={<IntlMessages id="Temperature" />}
                                  style={{ width: "100%" }}
                                >
                                  <InputNumber
                                    style={{ width: "100%" }}
                                    size="large"
                                    placeholder="Temperature on the day"
                                    min={0}
                                    max={1000}
                                    addonAfter="&#8451;"
                                  />
                                </Form.Item>
                              </TemperatureInput>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <Form.Item
                                    name={["activity", "wind_direction"]}
                                    className="isoInputWrapper"
                                    label={<IntlMessages id="Wind Direction" />}
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                    ]}
                                  >
                                    {renderOptionWindDirection(windDirection)}
                                  </Form.Item>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 12, offset: 1 }}
                                >
                                  <Form.Item
                                    name={["activity", "wind_speed"]}
                                    className="isoInputWrapper"
                                    label="Wind speed"
                                    rules={[
                                      {
                                        required: true,
                                        message: "This field is required",
                                      },
                                      {
                                        type: "number",
                                      },
                                    ]}
                                    style={{ width: "100%" }}
                                  >
                                    <InputNumber
                                      size="large"
                                      placeholder="Input wind speed"
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Form.Item
                                name={["activity", "moon_cycle"]}
                                className="isoInputWrapper"
                                label={<IntlMessages id="Moon cycle" />}
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                              >
                                {renderOptionMoonCycle(moonCycle)}
                              </Form.Item>
                              <Row>
                                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                  <TemperatureInput>
                                    <Form.Item
                                      name={["activity", "dew_point"]}
                                      className="isoInputWrapper"
                                      label={<IntlMessages id="Dew Point" />}
                                      style={{ width: "100%" }}
                                    >
                                      <InputNumber
                                        style={{ width: "100%" }}
                                        size="large"
                                        placeholder="Input dew point"
                                        min={0}
                                        max={1000}
                                        addonAfter="&#8451;"
                                      />
                                    </Form.Item>
                                  </TemperatureInput>
                                </Col>
                                <Col
                                  xs={{ span: 24 }}
                                  md={{ span: 12, offset: 1 }}
                                >
                                  <TemperatureInput>
                                    <Form.Item
                                      name={["activity", "humidity"]}
                                      className="isoInputWrapper"
                                      label={<IntlMessages id="Humidity" />}
                                      style={{ width: "100%" }}
                                    >
                                      <InputNumber
                                        style={{ width: "100%" }}
                                        size="large"
                                        placeholder="Input humidity"
                                        min={0}
                                        max={1000}
                                        addonAfter="&#8451;"
                                      />
                                    </Form.Item>
                                  </TemperatureInput>
                                </Col>
                              </Row>
                            </>
                          );
                        }
                      }
                    }}
                  </Form.Item>
              </Form>

            )}
              </TabPane>
              </Tabs>
              
    </HarvestModalWrapper>
  )
}
const AcreageInput = styled.div`
  display: flex;
  align-items: flex-start;
`;
const SuffixAddon = styled.span`
  margin-top: 30px;
  margin-bottom: 5px;
  line-height: 38px;
  color: #747784 !important;
  flex-shrink: 0;
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
  border-right-width: 1px !important;
  min-width: 50px;
  background-color: #f8f9fa;
  border: solid #d9d9d9;
  border-width: 1px 0;
  white-space: nowrap;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
`;
const TemperatureInput = styled.div`
  display: flex;
  align-items: flex-start;
`;